import React from 'react';
import { useDevMode } from '@/hooks/useDevMode';
import { getRoleDisplayName } from '@/lib/rolePermissions';
import { Button } from '@/components/ui/button';
import { Bug, X } from 'lucide-react';

export const DevModeBanner: React.FC = () => {
  const { simulatedRole, setSimulatedRole, isSimulating } = useDevMode();

  if (!isSimulating || !simulatedRole) {
    return null;
  }

  return (
    <div className="bg-amber-100 border-b border-amber-200 text-amber-800 text-center py-1.5 text-sm flex items-center justify-center gap-2">
      <Bug className="h-4 w-4" />
      <span>
        Du simulerar rollen <strong>"{getRoleDisplayName(simulatedRole)}"</strong>
      </span>
      <Button 
        size="sm" 
        variant="ghost" 
        onClick={() => setSimulatedRole(null)}
        className="h-6 px-2 text-amber-700 hover:text-amber-900 hover:bg-amber-200"
      >
        <X className="h-3 w-3 mr-1" />
        Återställ
      </Button>
    </div>
  );
};
